import { FC, useContext, useEffect, useState } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  Paper,
  Select,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Backdrop,
  CircularProgress,
  Container,
  MenuItem,
} from "@mui/material";
import Cookies from "universal-cookie";
import axios, { AxiosInstance } from "axios";

import {
  AllMounth,
  profilToAccessCommissionCommercialGRC,
} from "../../../../constants/Constants";
import { urlApi } from "../../parametrage/Pays/RowPays";
import CheckAttr from "../../../../utils/CheckAttr";
import { StyledTableCell, tableStyle } from "../../parametrage/Pays/Pays";
import { ICommissionCommerciauxDRC } from "./ICommissionCommerciauxDRC";
import RowCommissionCommerciauxGrc from "./RowCommissionCommerciauxGrc";
import { DataRef } from "../../../../types/DataRef";
import { ConnectedUser } from "../../../../utils/utils";
import SecondNiveauCommission from "./SecondNiveauCommission";
import { yearsToDisplayCommission } from "../MainCommission";

interface FilterParams {
  month?: string;
  year?: string;
  client?: string;
  operation?: string;
}

const initialFilter: FilterParams = {
  month: "",
  year: "",
  client: "",
  operation: "",
};

const CommissionCommerciauxGrc = () => {
 
  // Data ref
  const [allUserRef, setAllUserRef] = useState<DataRef[]>([]);
  const [allClient, setAllClient] = useState<DataRef[]>([]);
  const [allOperation, setAllOperation] = useState<DataRef[]>([]);

  const [filterParams, setFilterParams] = useState<FilterParams>(initialFilter);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [filterUser, setFilterUser] = useState<number | string>("");
  const userConnected = ConnectedUser();
  const isCommercialDRC = profilToAccessCommissionCommercialGRC.includes(
    userConnected?.profils?.libelle
  );

  const AllMounthCorriger = Number(filterParams?.year) ===  new Date().getFullYear() ? AllMounth?.filter((mounth) => mounth?.id <= new Date().getMonth() + 1) : AllMounth;

  // Data
  const [allUserWithArticleCommission, setAllUserWithArticleCommission] =
    useState<ICommissionCommerciauxDRC[]>([]);

  const cookies = new Cookies();
  const token: string = cookies.get("jwt");
  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  // getData
  const getUserWithCommission = () => {
    const data = {
      userId: isCommercialDRC ? userConnected?.id : filterUser,
      annee: filterParams?.year,
      mois: filterParams?.month,
      operation: filterParams?.operation,
      client: filterParams?.client,
    };
    setIsLoading(true);
    http
      .post("commission/alluser/article-commission", data)
      .then((res) => {
        setAllUserWithArticleCommission(res.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getDataRef = () => {
    setIsLoading(true);
    http
      .get("commission/alluser/hasCommission")
      .then((res) => {
        setAllUserRef(res.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });

    http
      .get("operation/get-clients/distinct")
      .then((res) => {
        setAllClient(res.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getOperationByClient = () => {
    setIsLoading(true);
    CheckAttr(filterParams?.client) &&
      http
        .get(`operation/get-operations/via-client/${filterParams?.client}`)
        .then((res) => {
          setAllOperation(res.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
  };

  // HandleChange
  const handleChangeFilter = (e: any) => {
    const { name, value } = e.target;

    if (name === "client") {
      setFilterParams({
        ...filterParams,
        operation: "",
        [name]: value,
      });
    } else {
      setFilterParams({
        ...filterParams,
        [name]: value,
      });
    }
  };

  // UseEffect
  useEffect(() => {
    getUserWithCommission();
  }, [filterParams, filterUser]);

  useEffect(() => {
    getOperationByClient();
  }, [filterParams?.client]);

  useEffect(() => {
    getDataRef();
  }, []);
  console.log(filterParams);

  return (
    <>
      <Container maxWidth="xl">
        <Grid container spacing={0.5} columns={{ xs: 6, sm: 10, md: 12 }}>
          <Grid item xs={0} sm={0} md={2} spacing={1.5}></Grid>
          <Grid item xs={0} sm={2} md={2} spacing={1.5}>
            <FormControl sx={{ minWidth: 190 }}>
              <InputLabel
                id="demo-simple-select-label"
                color="warning"
                sx={{ mt: -1 }}
              >
                Client
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                sx={{ background: "#fff" }}
                size="small"
                color="warning"
                label="Age"
                value={filterParams?.client}
                onChange={handleChangeFilter}
                name="client"
              >
                <MenuItem value={undefined} dense></MenuItem>
                {allClient.map((cl) => (
                  <MenuItem key={cl?.id} value={cl?.id} dense>
                    {cl?.libelle}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={0} sm={2} md={2} spacing={1.5}>
            <FormControl sx={{ minWidth: 190 }}>
              <InputLabel
                id="demo-simple-select-label"
                color="warning"
                sx={{ mt: -1 }}
              >
                Operation
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                sx={{ background: "#fff" }}
                size="small"
                color="warning"
                label="operation"
                value={filterParams?.operation}
                onChange={handleChangeFilter}
                name="operation"
              >
                <MenuItem value={undefined} dense></MenuItem>
                {allOperation.map((op) => (
                  <MenuItem key={op?.id} value={op?.id} dense>
                    {op?.libelle}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={0} sm={2} md={2} spacing={1.5}>
            <FormControl sx={{ minWidth: 190 }}>
              <InputLabel
                id="demo-simple-select-label"
                color="warning"
                sx={{ mt: -1 }}
              >
                Commerciaux/DRC
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                sx={{ background: "#fff" }}
                size="small"
                color="warning"
                label="Age"
                value={filterUser}
                onChange={(e: any) => setFilterUser(e.target.value)}
                disabled={isCommercialDRC}
              >
                <MenuItem value={undefined} dense></MenuItem>
                {allUserRef.map((userRef) => (
                  <MenuItem key={userRef?.id} value={userRef?.id} dense>
                    {userRef?.libelle}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4} sm={4} md={2}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel
                htmlFor="Mois"
                color="warning"
                shrink={CheckAttr(filterParams?.month)}
                sx={{ mt: -1 }}
              >
                Mois
              </InputLabel>
              <Select
                id="Mois"
                native
                color="warning"
                sx={{ background: "#fff" }}
                size="small"
                value={filterParams?.month}
                name="month"
                onChange={handleChangeFilter}
                label="Mois"
              >
                <option value={0}></option>
                {AllMounthCorriger.map((m) => (
                  <option value={m.id}>{m.mounth}</option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4} sm={4} md={2}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel
                htmlFor="year"
                color="warning"
                shrink={CheckAttr(filterParams?.year)}
                sx={{ mt: -1 }}
              >
                Année
              </InputLabel>
              <Select
                id="year"
                native
                color="warning"
                sx={{ background: "#fff" }}
                size="small"
                name="year"
                value={filterParams?.year}
                onChange={handleChangeFilter}
                label="year"
                inputProps={{
                  name: "year",
                }}
              >
                <option value={0}></option>
                {yearsToDisplayCommission.map((y) => (
                  <option value={y}>{y}</option>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <br></br>

        <TableContainer component={Paper} style={tableStyle}>
          {isCommercialDRC ? (
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">Client</StyledTableCell>
                  <StyledTableCell align="center">Operation</StyledTableCell>
                  <StyledTableCell align="center">désignation article</StyledTableCell>
                  <StyledTableCell align="center">mois - année</StyledTableCell>
                  <StyledTableCell align="center">Type{" "}</StyledTableCell>
                  <StyledTableCell align="center">CA</StyledTableCell>
                  <StyledTableCell align="center">Taux de commission</StyledTableCell>
                  <StyledTableCell align="center">Commission</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allUserWithArticleCommission[0]?.herArticleWithCommission?.map(
                  (article) => (
                    <SecondNiveauCommission article={article} />
                  )
                )}
              </TableBody>
            </Table>
          ) : (
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell />
                  <StyledTableCell align="center">prenom</StyledTableCell>
                  <StyledTableCell align="center">Nom</StyledTableCell>
                  <StyledTableCell align="center">Email</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allUserWithArticleCommission?.map((user) => (
                  <RowCommissionCommerciauxGrc
                    userWithArticleCommission={user}
                  />
                ))}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </Container>
      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>

    </>
  );
};

export default CommissionCommerciauxGrc;
